import { authorizedDelete, authorizedGet, authorizedPost, authorizedPut } from "./AuthService";
import { useState, useEffect } from "react";
import { setDynamicSchema } from "../configs/PermissionsConfig";

export const RoleReqHandler = () => {
    const [permissions, setPermissions] = useState(null);
    const [isPermissionsLoading, setIsPermissionsLoading] = useState(false);
    const [dynamicMaps, setDynamicMaps] = useState({roleMap: {}, roleNameMap: {}})
    const [roleReqs, setRoleReqs] = useState([]);

    const getFullSchema = async () => {
        try {
            const response = await authorizedGet("/assembler");
            const resData = await response.body.json();
            const roleMap = {};
            const roleNameMap = {};
            resData.forEach(item => {
                roleMap[item.label] = item.name;
                roleNameMap[item.name] = item.label;
            });

            setDynamicMaps({roleMap: roleMap, roleNameMap: roleNameMap});
            //Pass the schema to PermissionsConfig
            setDynamicSchema(resData);
            
            // console.log("Full schema: ", resData);
            return {success: true, maps: {roleMap, roleNameMap}}
        } catch(e) {
            console.error("Error al obtener el esquema: ", e);
            return {success: false, maps: {}}
        }
    }
    
    const getRoles = async () => {
        try {
            setIsPermissionsLoading(true);
            const response = await authorizedGet("/admin/getRoles")
            const data = await response.body.json();
            // console.log("Data: ", data);
            setPermissions(data);
        } catch(e) {
            console.error("Error al obtener los roles: ", e);
            setPermissions({});
        } finally {
            setIsPermissionsLoading(false);
        }
    }

    const createRole = async (roleName, actions, labelMap) => {
        try {
            const payload = {
                roleName: roleName,
                actions: actions,
                labelMap: labelMap
            };

            const response = await authorizedPost("/admin/createRole", payload);
            const resData = await response.body.json();

            // console.log("Rol creado: ", resData);

            return {success: true, data: resData}
        } catch(e) {
            console.error("Error al crear el rol: ", e);
            const errData = await new Response(e.response.body).json();
            const message = errData.message;
            return {success: false, message: message};
        } 
    }

    const updateRole = async (roleKey, actions, labelMap) => {
        try {
            const payload = {
                roleKey: roleKey,
                actions: actions,
                labelMap: labelMap
            }

            const response = await authorizedPut("/admin/updateRole", payload);
            const resData = await response.body.json();
            
            // console.log("Rol actualizado: ", resData);
            return {success: true, data: resData};
        } catch(e) {
            console.error("Error al editar el rol: ", e);
            const errData = await new Response(e.response.body).json();
            const message = errData.message;
            return {success: false, message: message};
        }
    }
    
    const deleteRole = async(roleKey) => {
        try {
            const response = await authorizedDelete("/admin/deleteRole", {roleKey: roleKey});
            const resData = await response.body.json();

            return {success: true};
        }catch (e) {
            console.error("Error al eliminar el rol: ", e);
            const errData = await new Response(e.response.body).json();
            const message = errData.message;
            return {success: false, message: message};
        }
    }

    const createRoleChangeReq = async(data) => {
        try {
            const response = await authorizedPost("/rolereq/roleChangeRequest", data)
            const resData = await response.body.json();

            // console.log("ResData: ", resData);
            return {success: true}
        } catch(e) {
            console.error("Error al crear la solicitud de cambio de rol: ", e);
            return {success: false}
        }
    }

    const getRoleChangeReq = async() => {
        try {
            const response = await authorizedGet("/rolereq/getAll");
            const resData = await response.body.json();
            setRoleReqs(resData);

            // console.log("Resdata: ", resData);
            return {success: true}
        } catch(e) {
            console.error("Error al obtener las solicitudes de cambio de rol: ", e);
            return {success: false};
        }
    }

    const updateRoleChangeReq = async(data) => {
        try {
            const response = await authorizedPut("/rolereq/update", data);
            const resData = await response.body.json();
            getRoleChangeReq();

            // console.log("ResData: ", resData);

            return {success: true}
        } catch(e) {
            console.error("Error al actualizar la solicitud de cambio de rol: ", e);
            return {success: false}
        }
    }

    useEffect(() => {
        getRoles();
        getRoleChangeReq();
    }, []);

    return {permissions, isPermissionsLoading, roleMap: dynamicMaps.roleMap, roleNameMap: dynamicMaps.roleNameMap, roleReqs, getFullSchema, getRoles, createRole, updateRole, deleteRole, createRoleChangeReq, getRoleChangeReq, updateRoleChangeReq}
}